import { compareScenarios, type Scenario, type ScenarioMetric } from "@/lib/calc/scenarios";

/** Up to 3 scenarios side by side. Each metric row shows the values; a second line under later scenarios shows the change from scenario 1. */
export function ScenarioCompare({ scenarios, metrics, caption = "Scenario comparison" }: { scenarios: Scenario[]; metrics: ScenarioMetric[]; caption?: string }) {
  const list = scenarios.slice(0, 3);
  const rows = compareScenarios(list, metrics);
  return (
    <div className="border rounded-xl overflow-x-auto" data-testid="scenario-compare">
      <table className="w-full text-sm">
        <caption className="sr-only">{caption}</caption>
        <thead className="bg-card border-b">
          <tr className="text-left text-muted-foreground">
            <th scope="col" className="p-2 pl-4">Measure</th>
            {list.map((s) => <th key={s.id} scope="col" className="p-2 text-right">{s.name}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.key} className="border-b last:border-0">
              <th scope="row" className="p-2 pl-4 text-left font-normal">{r.label}</th>
              {r.cells.map((c, i) => (
                <td key={i} className="p-2 text-right">
                  {c}
                  {r.deltas[i] && <span className="block text-xs text-muted-foreground" data-testid="scenario-delta">{r.deltas[i]} vs {list[0].name}</span>}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
